/* WR Beautiful — Judge.me content corrections applied at render time.

   Two defects come from the 2026-06/07 Trendyol imports and cannot be fixed in
   the Judge.me dashboard on the current plan (reviews there are delete-only, not
   editable). Both are display-level, so the theme corrects them instead.

   1. Every imported review carries the literal title
      "(Trendyol'da doğrulanmış alıcı)" / "(Hepsiburada'da doğrulanmış alıcı)".
      The author name already reads "Trendyol Alıcısı" and Judge.me prints its
      own verified badge, so the title is a third copy of the same fact — and on
      a phone it costs the review body one to two of its four lines. Only an
      exact match on the boilerplate is removed; a real title a customer writes
      later is left alone.

   2. she-rice-review-photo.jpg is attached to the 5-star She's Rice review by
      "S** N** K**", but the photo is of the compact's scratched mirror and
      belongs to a 1-star complaint that was never imported. It is orphaned
      evidence contradicting the review it illustrates, on the store's
      highest-traffic PDP. Remove it (and its now-empty tile) until the review
      data itself is corrected — see BL-M9.

   Judge.me renders asynchronously and re-renders on filter/paginate, so both
   passes run again on mutation. */

(function () {
  'use strict';

  var BOILERPLATE_TITLE = /^\(\s*(?:Trendyol|Hepsiburada)'da doğrulanmış alıcı\s*\)$/i;
  var ORPHANED_PHOTO = 'she-rice-review-photo';
  var ROOTS = '.jdgm-widget, .jdgm-carousel, [data-widget-container], #judgeme_product_reviews';

  function stripBoilerplateTitles(root) {
    var nodes = root.querySelectorAll('div, span, p, h1, h2, h3, h4, h5, h6, strong, b');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.childElementCount) continue;
      if (!BOILERPLATE_TITLE.test((el.textContent || '').trim())) continue;
      el.remove();
    }
  }

  function removeOrphanedPhoto(root) {
    var imgs = root.querySelectorAll('img[src*="' + ORPHANED_PHOTO + '"]');
    for (var i = 0; i < imgs.length; i++) {
      /* Drop the tile/link wrapper too, otherwise the media grid keeps an empty
         cell where the photo used to sit. */
      var target = imgs[i];
      var parent = target.parentElement;
      if (parent && parent !== root && parent.childElementCount === 1) target = parent;
      target.remove();
    }
  }

  function clean() {
    var roots = document.querySelectorAll(ROOTS);
    for (var i = 0; i < roots.length; i++) {
      stripBoilerplateTitles(roots[i]);
      removeOrphanedPhoto(roots[i]);
    }
  }

  function start() {
    clean();
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        clean();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
